<mat-spinner diameter="50" [strokeWidth]="2"></mat-spinner>
